import { DEFAULT_GETTERS } from '@/modules/b2b/constants';

export default {
  ...DEFAULT_GETTERS,
  notificationsLists: (state) => state.notificationsLists || [],
  notificationsBadges: (state) => state.notificationsBadges || {},
  totalCount: (state) => state.totalCount,
  quotationDetailData: (state) => state.quotationDetailData,
  numberBadge: (state) => state.numberBadge?.data,
  quotationsPending: (state) => state.quotationsPending?.data || [],
  quotationsApproved: (state) => state.quotationsApproved?.data || [],
  quotationsRejected: (state) => state.quotationsRejected?.data || []
};
